import React from 'react';

import { useIntlDictionary } from 'hooks/useIntlDictionary';
import {
  TableTr,
  TableWrapper,
  TableHead,
  TableTh,
  TableBody,
} from 'design/table';
import { Promocode, PromocodesTableSortableField } from 'types/state/promocode';
import { PromocodesTableRow } from './PromocodesTableRow';

type Props = {
  promocodes: Promocode[];
  sortedBy: PromocodesTableSortableField;
  ascendingSort: boolean;
  activeItemId?: number;
  onSortChange(nextSortBy: PromocodesTableSortableField): void;
  onItemClick(item: number): void;
};

export const PromocodesTable = (props: Props) => {
  const {
    promocodes,
    sortedBy,
    ascendingSort,
    activeItemId,
    onSortChange,
    onItemClick,
  } = props;

  const { promocodesTableColumns: ownDictionary } = useIntlDictionary();

  const onIdClick = React.useCallback(() => {
    onSortChange('id');
  }, [onSortChange]);

  const onValueClick = React.useCallback(() => {
    onSortChange('value');
  }, [onSortChange]);

  const onOrgClick = React.useCallback(() => {
    // onSortChange('org');
  }, []);

  const onPersonClick = React.useCallback(() => {
    // onSortChange('person');
  }, []);

  const onCreatedAtClick = React.useCallback(() => {
    onSortChange('createdAt');
  }, [onSortChange]);

  const onStatusClick = React.useCallback(() => {
    onSortChange('status');
  }, [onSortChange]);

  const onExpiresAtClick = React.useCallback(() => {
    onSortChange('expiresAt');
  }, [onSortChange]);

  const onActivatedAtClick = React.useCallback(() => {
    onSortChange('activatedAt');
  }, [onSortChange]);

  const tableRowsNode = React.useMemo(() => {
    return promocodes.map((promocode) => (
      <PromocodesTableRow
        key={promocode.id}
        active={activeItemId === promocode.id}
        promocode={promocode}
        onClick={onItemClick}
      />
    ));
  }, [promocodes, activeItemId, onItemClick]);

  return (
    <TableWrapper>
      <TableHead>
        <TableTr>
          <TableTh
            size="xs"
            sorted={sortedBy === 'id'}
            ascending={ascendingSort}
            text={ownDictionary.id}
            onClick={onIdClick}
          />
          <TableTh
            size="m"
            ascending={ascendingSort}
            text={ownDictionary.value}
            onClick={onValueClick}
          />
          <TableTh
            size="auto"
            sorted={sortedBy === 'org'}
            ascending={ascendingSort}
            text={ownDictionary.org}
            onClick={onOrgClick}
          />
          <TableTh
            size="xxl"
            sorted={sortedBy === 'person'}
            ascending={ascendingSort}
            text={ownDictionary.person}
            onClick={onPersonClick}
          />
          <TableTh
            size="m"
            sorted={sortedBy === 'createdAt'}
            ascending={ascendingSort}
            text={ownDictionary.createdAt}
            onClick={onCreatedAtClick}
          />
          <TableTh
            size="m"
            sorted={sortedBy === 'status'}
            ascending={ascendingSort}
            text={ownDictionary.status}
            onClick={onStatusClick}
          />
          <TableTh
            size="m"
            sorted={sortedBy === 'activatedAt'}
            ascending={ascendingSort}
            text={ownDictionary.activatedAt}
            onClick={onActivatedAtClick}
          />
          <TableTh
            size="m"
            sorted={sortedBy === 'expiresAt'}
            ascending={ascendingSort}
            text={ownDictionary.expiresAt}
            onClick={onExpiresAtClick}
          />
        </TableTr>
      </TableHead>
      <TableBody>{tableRowsNode}</TableBody>
    </TableWrapper>
  );
};
